import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router'
import { Alert } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import StepZilla from 'react-stepzilla'
import { resetSiteRegistration, siteRegistrationCheck } from '@severed-links/common.redherrings-reducers/siteRegistration'
    
import './ProgressTracker.scss'
import * as s from './SignUp.scss'

import PassphraseStep1 from './PassphraseStep1'
import UsernameStep2 from './UsernameStep2'
import PasswordStep3 from './PasswordStep3'
import NameAndEmailStep4 from './NameAndEmailStep4'
import InfoConfirmStep5 from './InfoConfirmStep5'
import RegistrationDoneStep6 from './RegistrationDoneStep6'
import PublicAccountShell from '../Public/components/PublicAccountShell'

const SignUp = () => {

    const dispatch = useDispatch()
    const siteRegistration = useSelector(state => state.siteRegistration)

    useEffect(() => {
        dispatch(resetSiteRegistration())
        dispatch(siteRegistrationCheck())
    }, [])

    if (!siteRegistration) return null
    const steps = [
        { name: 'Passphrase', component: <PassphraseStep1 /> },
        { name: 'Username', component: <UsernameStep2 /> },
        { name: 'Password', component: <PasswordStep3 /> },
        { name: 'Name/Email', component: <NameAndEmailStep4 /> },
        { name: 'Confirm', component: <InfoConfirmStep5 /> },
        { name: 'Done!', component: <RegistrationDoneStep6 /> }
    ]
    const { isChecking, isOpen } = siteRegistration
    return (
        <PublicAccountShell
            eyebrow='Join REDHERRINGS'
            title='Get in the game.'
            description='Create your account, join your contests, and start making picks with your group.'
            icon='users'
            footer={<span>Already have an account? <Link to='/login'>Log in here</Link></span>}>
                <div className={s.flowHeading}>
                    <h2>Create your account</h2>
                    <p>Tell us a little about yourself to get started.</p>
                </div>
                <div className={s.signupContainer}>
                {!isChecking && isOpen ? 
                    <div>
                        <div className='step-progress'>
                            <StepZilla
                                steps={steps}
                                startAtStep={0}
                                showSteps
                                showNavigation
                                stepsNavigation
                                prevBtnOnLastStep
                                // backButtonText={<span><FontAwesomeIcon name='chevron-left' /> Back</span>}
                                backButtonText={'Back'}
                                backButtonCls={`btn btn-prev btn-light btn-lg ${s.prevButton}`}
                                // nextButtonText={<span>Next <FontAwesomeIcon name='chevron-right' /></span>}
                                nextButtonText={'Next'}
                                nextButtonCls={`btn btn-next btn-light btn-lg ${s.nextButton}${(siteRegistration.nextDisabled ? ' ' + s.nextDisabled : ``)}`}
                                preventEnterSubmission={false}
                                nextTextOnFinalActionStep={'Register'}
                            />
                        </div>
                    </div>
                : null}

                {!isChecking && !isOpen ?
                <Alert style={{ marginTop: '100px' }}>
                    This site is not accepting registrations for 
                    new users at this point.  Please check back 
                    later.
                </Alert>
                : null}

                </div>
        </PublicAccountShell>
    )
}

export default SignUp
